import { render, staticRenderFns } from "./detail_child_comment.vue?vue&type=template&id=9e851c1c&"
import script from "./detail_child_comment.vue?vue&type=script&lang=js&"
export * from "./detail_child_comment.vue?vue&type=script&lang=js&"
import style0 from "./detail_child_comment.vue?vue&type=style&index=0&id=9e851c1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports